import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import BOMSelectModal from "../common/BOMSelectModal";
import ItemSelectModal from "../common/ItemSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";
import { AssistWalkerTwoTone, CatchingPokemonSharp } from "@mui/icons-material";
import { IoMdReturnLeft } from "react-icons/io";

let newFileID = 1;
let realFiles = [];
function ProduceWorkRegModal({ title, onClose, handleRegSuccessSave, userTypeModalOption, qualityYnModalOption, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const itemApiRef = useGridApiRef();
  const lotApiRef = useGridApiRef();
  const createlotApiRef = useGridApiRef();
  const userApiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [createlotRows, setCreateLotRows] = useState([]);
  const [updateCreateLotRows, setUpdateCreateLotRows] = useState([]);
  const [createlotColumns, setCreateLotColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    produce_work_id: null,
    produce_work_number: '',
    produce_work_bom_id: 0,
    produce_work_bom_item_count: 0,
    produce_work_bom_name: '',
    produce_work_item_id: 0,
    produce_work_item_name: '',
    produce_work_item_type_name: '',
    produce_work_item_division_name: '',
    produce_work_item_spec: '',
    produce_work_start_datetime: (appStore.YYYY_MM_DD ? appStore.YYYY_MM_DD() : '').toString() + 'T09:00',
    produce_work_end_datetime: (appStore.YYYY_MM_DD ? appStore.YYYY_MM_DD() : '').toString() + 'T18:00',
    produce_work_count: 0,
    produce_work_complete_count: 0,
    produce_work_error_count: 0,
    produce_work_bigo: '',
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectBOMModalOpen, setSelectBOMModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');
  // 빠른 입력 처리용 디바운스/시퀀스
  const lotDebounceRef = useRef(null);
  const lotCalcSeqRef = useRef(0);
  // 생산 LotNo 시작번호(일자별)
  const [createLotNoStartNumber, setCreateLotNoStartNumber] = useState('1');

  const handleSetting = () => {
    setItemColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'produce_work_item_id', headerName: 'produce_work_item_id', headerAlign: 'center', align:'center' },
      { field: 'produce_work_item_name', headerName: '품목', width: 180, headerAlign: 'center', align:'left' },
      { field: 'produce_work_item_spec', headerName: '규격', width: 200, headerAlign: 'center', align:'left' },
      { field: 'produce_work_item_count', headerName: '사용수량', type: 'number', width: 100, headerAlign: 'center', align:'right', editable: true },
      { field: 'produce_work_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 100, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'produce_work_item_bigo', headerName: '비고', width: 250, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' }
    ]);

    setLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
      { field: 'lot_produce_work_item_id', headerName: 'lot_produce_work_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_produce_work_item_name', headerName: '품목', width: 130, headerAlign: 'center', align:'left' },
      { field: 'lot_produce_work_item_spec', headerName: '규격', width: 185, headerAlign: 'center', align:'left' },
      { field: 'lot_produce_work_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'lot_produce_work_save_workplace_id', headerName: 'lot_produce_work_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_produce_work_save_workplace_name', headerName: '사업장',width: 120, headerAlign: 'center'},
      { field: 'lot_produce_work_save_warehouse_id', headerName: 'lot_produce_work_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_produce_work_save_warehouse_name', headerName: '창고', width: 120, headerAlign: 'center', align:'left' },
      { field: 'lot_produce_work_save_section_id', headerName: 'lot_produce_work_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_produce_work_save_section_name', headerName: '구역',width: 120, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setCreateLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
      { field: 'lot_create_produce_work_item_id', headerName: 'lot_create_produce_work_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_create_produce_work_item_name', headerName: '품목', width: 130, headerAlign: 'center', align:'left' },
      { field: 'lot_create_produce_work_item_spec', headerName: '규격', width: 185, headerAlign: 'center', align:'left' },
      { field: 'lot_create_produce_work_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'lot_create_produce_work_save_workplace_id', headerName: 'lot_create_produce_work_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_create_produce_work_save_workplace_name', headerName: '사업장',width: 120, headerAlign: 'center'},
      { field: 'lot_create_produce_work_save_warehouse_id', headerName: 'lot_create_produce_work_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_create_produce_work_save_warehouse_name', headerName: '창고', width: 120, headerAlign: 'center', align:'left' },
      { field: 'lot_create_produce_work_save_section_id', headerName: 'lot_create_produce_work_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_create_produce_work_save_section_name', headerName: '구역',width: 120, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'produce_work_user_id', headerName: 'produce_work_user_id', width: 0, headerAlign: 'center' },
      { field: 'produce_work_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'produce_work_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'produce_work_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'produce_work_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'produce_work_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setItemColumnVisibilityModel({
      id: false,
      actions: true,
      produce_work_item_id: false,
      produce_work_item_name: true,
      produce_work_item_spec: true,
      produce_work_item_count: true,
      produce_work_quality_exam_yn: false,
      produce_work_item_bigo: true,
      row_type: false,
      update_type: false
    });

    setLotColumnVisibilityModel({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_produce_work_item_id: false,
      lot_produce_work_item_name: true,
      lot_produce_work_item_spec: true,
      lot_produce_work_quality_exam_yn: false,
      lot_produce_work_save_workplace_id: false,
      lot_produce_work_save_workplace_name: true,
      lot_produce_work_save_warehouse_id: false,
      lot_produce_work_save_warehouse_name: true,
      lot_produce_work_save_section_id: false,
      lot_produce_work_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setCreateLotColumnVisibilityModel({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_create_produce_work_item_id: false,
      lot_create_produce_work_item_name: true,
      lot_create_produce_work_item_spec: true,
      lot_create_produce_work_quality_exam_yn: false,
      lot_create_produce_work_save_workplace_id: false,
      lot_create_produce_work_save_workplace_name: true,
      lot_create_produce_work_save_warehouse_id: false,
      lot_create_produce_work_save_warehouse_name: true,
      lot_create_produce_work_save_section_id: false,
      lot_create_produce_work_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: true,
      produce_work_user_id: false,
      produce_work_user_name: true,
      produce_work_user_dept_name: true,
      produce_work_user_position_name: true,
      produce_work_user_type: true,
      produce_work_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    produce_work_item_id: false,
    produce_work_item_name: true,
    produce_work_item_spec: true,
    produce_work_item_count: true,
    produce_work_quality_exam_yn: true,
    produce_work_item_bigo: true,
    row_type: false,
    update_type: false
  });

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_produce_work_item_id: false,
    lot_produce_work_item_name: true,
    lot_produce_work_item_spec: true,
    lot_produce_work_quality_exam_yn: true,
    lot_produce_work_save_workplace_id: false,
    lot_produce_work_save_workplace_name: true,
    lot_produce_work_save_warehouse_id: false,
    lot_produce_work_save_warehouse_name: true,
    lot_produce_work_save_section_id: false,
    lot_produce_work_save_section_name: true,
    row_type: false,
    update_type: false
  });

  
  const [createlotColumnVisibilityModel, setCreateLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_create_produce_work_item_id: false,
    lot_create_produce_work_item_name: true,
    lot_create_produce_work_item_spec: true,
    lot_create_produce_work_quality_exam_yn: false,
    lot_create_produce_work_save_workplace_id: false,
    lot_create_produce_work_save_workplace_name: true,
    lot_create_produce_work_save_warehouse_id: false,
    lot_create_produce_work_save_warehouse_name: true,
    lot_create_produce_work_save_section_id: false,
    lot_create_produce_work_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    produce_work_user_id: false,
    produce_work_user_name: true,
    produce_work_user_dept_name: true,
    produce_work_user_position_name: true,
    produce_work_user_type: true,
    produce_work_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: true,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    // OK/NG 합계 계산
    const ok = Number(inputs.produce_work_complete_count) || 0;
    const ng = Number(inputs.produce_work_error_count) || 0;
    const total = ok + ng;

    if (total > 99999) {
      setInputs(prev => ({ ...prev, produce_work_count: 0, produce_work_complete_count: 0, produce_work_error_count: 0 }));
      return;
    }

    // 1) 합계 필드만 즉시 반영
    setInputs(prev => ({ ...prev, produce_work_count: total }));

    
    // 3) Lot 생성/갱신만 디바운스 유지
    if (lotDebounceRef.current) clearTimeout(lotDebounceRef.current);
    lotDebounceRef.current = setTimeout(() => {

      // 2) ✅ 자재 사용수량 (디바운스 제거)
      if (inputs.produce_work_bom_id) {
        applyTotalToAllItems(total);
      }
      
      const localSeq = lotCalcSeqRef.current + 1;
      lotCalcSeqRef.current = localSeq;

      const changeDate = (inputs.produce_work_start_datetime || '').slice(0, 10) || appStore.YYYY_MM_DD();
      if (!changeDate) return;

      axios.get('/api/Common/LotNoStartNumber', {
        params: { type: 'W', date: changeDate }
      }, { withCredentials: true })
      .then((response) => {
        if (localSeq !== lotCalcSeqRef.current) return; // 오래된 응답 무시
        setCreateLotNoStartNumber(response.data);

        const okQty = Number(inputs.produce_work_complete_count) || 0;
        const finishedRow = {
          id: 0,
          produce_work_item_id: inputs.produce_work_item_id,
          produce_work_item_name: inputs.produce_work_item_name,
          produce_work_item_spec: inputs.produce_work_item_spec,
          produce_work_item_count: okQty,
          produce_work_quality_exam_yn: 'N',
          row_type: 'A',
          update_type: 'U'
        };
        // 생산 Lot(완제품)만 생성
        createLotRow([finishedRow], finishedRow, 'A', changeDate, response.data);
      })
      .catch((error) => {
        console.log(error);
      });
    }, 400);

    return () => {
      if (lotDebounceRef.current) clearTimeout(lotDebounceRef.current);
    };
  }, [inputs.produce_work_complete_count, inputs.produce_work_error_count, inputs.produce_work_item_id, inputs.produce_work_start_datetime]);
  
  const applyTotalToAllItems = (total) => {
    const batchSize = Math.abs(Number(inputs.produce_work_bom_item_count) || 0);
    const t = Math.abs(Number(total) || 0);
    const setCnt = batchSize > 0 ? Math.ceil(t / batchSize) : 0;

    for (const r of itemRows) {
      if (r.row_type === 'A' && r.update_type === 'N') continue; // 빈 추가행 스킵
      const perBatch = Number(r.bom_input_per_batch ?? 1);
      const needed = setCnt * perBatch;
      processItemRowUpdate({ ...r, produce_work_item_count: needed }, r);
    }
  };
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        produce_work_item_id: '',
        produce_work_item_name: '',
        produce_work_item_spec: '',
        produce_work_item_count: '',
        produce_work_quality_exam_yn: 'N',
        produce_work_item_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [itemRows]);
  
  useEffect(() => {
    // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        produce_work_user_id: '',
        produce_work_user_name: '',
        produce_work_user_dept_name: '',
        produce_work_user_position_name: '',
        produce_work_user_type: '',
        produce_work_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시

    setSelectModalTitle('BOM 목록')
    setSelectBOMModalOpen(true);
    
  };

  const handleBOMClick = (object) => {
    setItemRows([]);
    setLotRows([]);
    setCreateLotRows([]);
    // 상태 업데이트(스테일 방지용 functional 업데이트)
    setInputs(prev => ({
      ...prev,
      produce_work_count:object.bom_item_count,
      produce_work_complete_count:object.bom_item_count,
      produce_work_error_count: 0,
      produce_work_bom_id: object.id,
      produce_work_bom_item_count: object.bom_item_count,
      produce_work_bom_name: object.bom_name,
      produce_work_item_id: object.item_id,
      produce_work_item_name: object.item_name,
      produce_work_item_type_name: object.item_type_name,
      produce_work_item_division_name: object.item_division_name,
      produce_work_item_spec: object.item_full_spec,
    }));

    const SEP = '▦';
    const s = v => String(v ?? '').split(SEP);                    // 안전 split
    const n = v => {                                              // 숫자 변환(빈값/NaN → 0)
      const t = String(v ?? '').replace(/,/g, '').trim();
      const f = parseFloat(t);
      return Number.isFinite(f) ? f : 0;
    };

    // bom
    const ids        = s(object.input_item_ids);
    const names      = s(object.input_item_names);
    const specs      = s(object.input_item_specs);
    const widths     = s(object.input_item_widths);
    const depths     = s(object.input_item_depths);
    const heights    = s(object.input_item_heights);
    const stocks     = s(object.input_item_stocks);
    const useStocks  = s(object.input_item_use_stocks);
    const count     = s(object.input_item_count);

    const N = Math.max(
      ids.length, names.length, specs.length,
      widths.length, depths.length, heights.length,
      stocks.length, useStocks.length, count.length
    );

    // 투입자재
    for (let i = 0; i < N; i++) {
      if((names[i] ?? '').trim() === '' && (ids[i] ?? '').trim() === ''){
        continue;
      }

      const o = {
        idx: i,
        input_item_id: (ids[i] ?? '').trim(),
        input_item_name: (names[i] ?? '').trim(),
        input_item_spec: (specs[i] ?? '').trim(),
        input_item_full_sepc: (
                                ((specs[i] ?? '').trim()) +
                                appStore.ITEM_FULL_SPEC_MAKE(
                                  n(widths[i]),
                                  n(depths[i]),
                                  n(heights[i])
                                )
                              ).trim(),
        width: n(widths[i]),
        depth: n(depths[i]),
        height: n(heights[i]),
        count: n(count[i]),
        stock: n(stocks[i]),
        use_stock: n(useStocks[i]),
      };
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(i)+1,
        produce_work_item_id: (ids[i] ?? '').trim(),
        produce_work_item_name: (names[i] ?? '').trim(),
        produce_work_item_spec: ((specs[i] ?? '').trim() + ' ' + (n(widths[i]) + ' x ' + n(depths[i]) + ' x ' + n(heights[i]))),
        //produce_work_item_count: count[i],
        produce_work_item_count: 0,
        produce_work_quality_exam_yn: 'N',
        produce_work_item_bigo: '',
        row_type:'A',
        update_type: 'U'
      }]);
    }
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'produce_work_partner_manager_phone'){ // 전화번호인 경우
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    if(newRow.produce_work_item_count > 99999){
      return;
    }
    // 생산작업 품목 Rows Update
    // 날짜형식 fomat 맞춰주기

    
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.produce_work_item_id !== oldRow.produce_work_item_id || newRow.produce_work_item_name !== oldRow.produce_work_item_name || newRow.produce_work_item_count !== oldRow.produce_work_item_count || newRow.produce_work_quality_exam_yn !== oldRow.produce_work_quality_exam_yn || newRow.produce_work_item_bigo !== oldRow.produce_work_item_bigo){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_produce_work_item_id = '';
      var row_produce_work_item_name = '';
      var row_produce_work_item_spec = '';
      var row_produce_work_item_count = '';
      var row_produce_work_quality_exam_yn = 'N';
      var row_produce_work_item_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.produce_work_item_id !== '' || newRow.produce_work_item_name !== '' || newRow.produce_work_item_spec !== '' || newRow.produce_work_item_count !== '' || newRow.produce_work_item_bigo !== '' || newRow.produce_work_quality_exam_yn !== 'N'){
          row_produce_work_item_id = newRow.produce_work_item_id;
          row_produce_work_item_name = newRow.produce_work_item_name;
          row_produce_work_item_spec = newRow.produce_work_item_spec;
          row_produce_work_item_count = newRow.produce_work_item_count;
          row_produce_work_quality_exam_yn = newRow.produce_work_quality_exam_yn;
          row_produce_work_item_bigo = newRow.produce_work_item_bigo;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        itemRows.map((data) => data.id === newRow.id 
          && (data.produce_work_item_id !== newRow.produce_work_item_id || data.produce_work_item_name !== newRow.produce_work_item_name || data.produce_work_item_spec !== newRow.produce_work_item_spec || data.produce_work_item_count !== newRow.produce_work_item_count || data.produce_work_quality_exam_yn !== newRow.produce_work_quality_exam_yn || data.produce_work_item_bigo !== newRow.produce_work_item_bigo)?
          (
            row_produce_work_item_id = data.produce_work_item_id,
            row_produce_work_item_name = data.produce_work_item_name,
            row_produce_work_item_spec = data.produce_work_item_spec,
            row_produce_work_item_count = data.produce_work_item_count,
            row_produce_work_quality_exam_yn = data.produce_work_quality_exam_yn,
            row_produce_work_item_bigo = data.produce_work_item_bigo
          ):""
        )
      }
      
      if(row_produce_work_item_id === '' && row_produce_work_item_name === '' && row_produce_work_item_spec === '' && row_produce_work_item_count === '' && row_produce_work_quality_exam_yn === 'N' && row_produce_work_item_bigo === ''){
        // 1. 값이 수정되지 않은 경우.
        if(updateItemRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateItemRows.length);
          setUpdateItemRows(prev => prev.filter(d => d.id !== newRow.id));
          setItemRows(prev => prev.map(d => d.id === newRow.id ? newNoDataArray : d));
          searchLotRow(newNoDataArray, 'O');
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }
        
        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateItemRows.length);
          setUpdateItemRows(prev => prev.map(d => d.id === newRow.id ? newUpdateDataArray : d));
          setItemRows(prev => prev.map(d => d.id === newRow.id ? newUpdateDataArray : d));
          searchLotRow(newUpdateDataArray, 'A');
          // 생산Lot 생성/갱신 동기화
          const changeDate = (inputs.produce_work_start_datetime || '').slice(0, 10) || appStore.YYYY_MM_DD();
          createLotRow(itemRows, newUpdateDataArray, 'A', changeDate);
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateItemRows.length);
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(prev => prev.map(d => d.id === newRow.id ? newUpdateDataArray : d));
          searchLotRow(newUpdateDataArray, 'A');
          // 생산Lot 생성/갱신 동기화
          const changeDate = (inputs.produce_work_start_datetime || '').slice(0, 10) || appStore.YYYY_MM_DD();
          createLotRow(itemRows, newUpdateDataArray, 'A', changeDate);
        }
        
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  // item row 업데이트와 동시에 lot row 조회
  const searchLotRow = async (tempNewUpdateData, tempType, startCount = 0) => {
    if (tempNewUpdateData.produce_work_item_count === null || tempNewUpdateData.produce_work_item_count === '') {
      tempNewUpdateData.produce_work_item_count = 0;
      tempType = 'D';
    }

    if (tempType === 'D') { // 삭제
      setLotRows(prev => prev.filter(d => d.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows(prev => prev.filter(d => d.upper_id !== tempNewUpdateData.id));
      return true;
    }

    if (tempType === 'O') { // 원복
      setLotRows(prev => prev.filter(d => d.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows(prev => prev.filter(d => d.upper_id !== tempNewUpdateData.id));
      return true;
    }

    if (tempType === 'A') { // 업데이트/생성
      if (
        typeof itemRows.find((d) => d.id === tempNewUpdateData.id) !== 'undefined' &&
        (tempNewUpdateData.produce_work_item_count === 0 ||
        tempNewUpdateData.produce_work_item_count === '' ||
        tempNewUpdateData.produce_work_item_count === null)
      ) {
        setLotRows([]);
        setUpdateLotRows([]);
        return true;
      }

      if (tempNewUpdateData.produce_work_item_count < 0) {
        Swal.fire({
          title: '<p style="color:red">생산작업 수량 오류</p>',
          text: '생산작업 수량은 음수가 될 수 없습니다.',
          confirmButtonText: '확인'
        });

        processItemRowUpdate(
          {
            id: tempNewUpdateData.id,
            produce_work_item_id: tempNewUpdateData.produce_work_item_id,
            produce_work_item_name: tempNewUpdateData.produce_work_item_name,
            produce_work_item_spec: tempNewUpdateData.produce_work_item_spec,
            produce_work_item_count: '',
            produce_work_quality_exam_yn: tempNewUpdateData.produce_work_quality_exam_yn,
            produce_work_item_bigo: tempNewUpdateData.produce_work_item_bigo,
            row_type: tempNewUpdateData.row_type,
            update_type: tempNewUpdateData.update_type,
          },
          { ...tempNewUpdateData }
        );
        return false;
      }

      // 품목/수량 체크
      if (
        tempNewUpdateData.produce_work_item_id === '' ||
        tempNewUpdateData.produce_work_item_count === '' ||
        tempNewUpdateData.produce_work_item_count === '0'
      ) {
        setLotRows([]);
        setUpdateLotRows([]);
        return true;
      }

      // 먼저 기존 같은 upper_id 행 제거(함수형 업데이트)
      setLotRows(prev => prev.filter(d => d.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows(prev => prev.filter(d => d.upper_id !== tempNewUpdateData.id));

      // 재고 조회 후 LOT 생성
      return axios
        .get('/api/Common/StockFIFOInfo', {
          params: {
            item_id: tempNewUpdateData.produce_work_item_id,
            item_count: tempNewUpdateData.produce_work_item_count
          }
        }, { withCredentials: true })
        .then((response) => {
          const lot_array = response.data;

          if (lot_array.length >= Number(tempNewUpdateData.produce_work_item_count)) {
            // prev(최신 상태)를 기준으로 id를 계산하여 충돌 방지
            setLotRows(prev => {
              const start_lot_id = Number(appStore.getMaxListID(prev)) + 1; // 여기서 prev로 계산!!
              const count = Number(tempNewUpdateData.produce_work_item_count);

              const create_lot_array = Array.from({ length: count }, (_, i) => ({
                id: start_lot_id + i,
                upper_id: tempNewUpdateData.id,
                lot_no: lot_array[i].item_lotno,
                lot_produce_work_item_id: tempNewUpdateData.produce_work_item_id,
                lot_produce_work_item_name: tempNewUpdateData.produce_work_item_name,
                lot_produce_work_item_spec: tempNewUpdateData.produce_work_item_spec,
                lot_produce_work_quality_exam_yn: tempNewUpdateData.produce_work_quality_exam_yn,
                lot_produce_work_save_workplace_id: lot_array[i].item_lot_save_workplace_id ?? null,
                lot_produce_work_save_workplace_name: lot_array[i].item_lot_save_workplace_name ?? null,
                lot_produce_work_save_warehouse_id: lot_array[i].item_lot_save_warehouse_id ?? null,
                lot_produce_work_save_warehouse_name: lot_array[i].item_lot_save_warehouse_name ?? null,
                lot_produce_work_save_section_id: lot_array[i].item_lot_save_section_id ?? null,
                lot_produce_work_save_section_name: lot_array[i].item_lot_save_section_name ?? null,
                row_type: 'A',
                update_type: 'U',
              }));

              // updateLotRows도 같은 배열로 동기화
              setUpdateLotRows(prev2 => [...prev2, ...create_lot_array]);

              return [...prev, ...create_lot_array];
            });

            return true;
          } else {
            Swal.fire({
              title: '<p style="color:red">생산작업 품목 재고 부족</p>',
              text: '품목의 가용 재고가 ' + (String(lot_array.length)).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' 입니다.',
              confirmButtonText: '확인'
            });

            processItemRowUpdate(
              {
                id: tempNewUpdateData.id,
                produce_work_item_id: tempNewUpdateData.produce_work_item_id,
                produce_work_item_name: tempNewUpdateData.produce_work_item_name,
                produce_work_item_spec: tempNewUpdateData.produce_work_item_spec,
                produce_work_item_count: '',
                produce_work_quality_exam_yn: tempNewUpdateData.produce_work_quality_exam_yn,
                produce_work_item_bigo: tempNewUpdateData.produce_work_item_bigo,
                row_type: tempNewUpdateData.row_type,
                update_type: tempNewUpdateData.update_type,
              },
              { ...tempNewUpdateData }
            );
            return false;
          }
        });
      }
    return true;
  };

  const processLotRowUpdate = (newRow, oldRow) => {
    // 날짜형식 fomat 맞춰주기
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.lot_no !== oldRow.lot_no && newRow.lot_produce_work_item_id !== oldRow.lot_produce_work_item_id && newRow.lot_produce_work_quality_exam_yn !== oldRow.lot_produce_work_quality_exam_yn){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_lot_no = '';
      var row_lot_produce_work_quality_exam_yn = 'N';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.lot_no !== oldRow.lot_no || newRow.lot_produce_work_quality_exam_yn !== oldRow.lot_produce_work_quality_exam_yn){
          
          row_lot_no = newRow.lot_no;
          row_lot_produce_work_quality_exam_yn = newRow.lot_produce_work_quality_exam_yn;
        
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        lotRows.map((data) => data.id === newRow.id 
          && (data.lot_no !== newRow.lot_no || data.lot_produce_work_quality_exam_yn !== newRow.lot_produce_work_quality_exam_yn)?
          (
            row_lot_no = data.lot_no,
            row_lot_produce_work_quality_exam_yn = data.row_lot_produce_work_quality_exam_yn
          ):""
        )
      }
      
      if(row_lot_no === '' && row_lot_produce_work_quality_exam_yn === 'N'){
        // 1. 값이 수정되지 않은 경우.
        if(updateLotRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.filter((data) => data.id !== newRow.id));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateLotRows.length; i++) {
          if(updateLotRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateLotRows.length);
          setUpdateLotRows(prevRows => [...prevRows, newUpdateDataArray]);
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  // 생산Lot(Row) 업데이트 처리
  const processCreateLotRowUpdate = (newRow, oldRow) => {
    const newUpdateDataArray = {
      ...newRow,
      update_type: 'U'
    };
    const newNoDataArray = {
      ...newRow,
      update_type: 'N'
    };

    // 변경 감지: 저장 위치/검사여부/로트번호(필요시)
    const changed = (
      newRow.lot_create_produce_work_save_workplace_id !== oldRow.lot_create_produce_work_save_workplace_id ||
      newRow.lot_create_produce_work_save_warehouse_id !== oldRow.lot_create_produce_work_save_warehouse_id ||
      newRow.lot_create_produce_work_save_section_id !== oldRow.lot_create_produce_work_save_section_id ||
      newRow.lot_create_produce_work_quality_exam_yn !== oldRow.lot_create_produce_work_quality_exam_yn
    );

    if (changed) {
      let row_save_workplace_id = null;
      let row_save_warehouse_id = null;
      let row_save_section_id = null;
      let row_quality_exam_yn = 'N';

      if (String(newRow.row_type) === 'A') {
        // 추가행은 입력이 있으면 변경으로 간주
        if (
          newRow.lot_create_produce_work_save_workplace_id !== null ||
          newRow.lot_create_produce_work_save_warehouse_id !== null ||
          newRow.lot_create_produce_work_save_section_id !== null ||
          newRow.lot_create_produce_work_quality_exam_yn !== 'N'
        ) {
          row_save_workplace_id = newRow.lot_create_produce_work_save_workplace_id;
          row_save_warehouse_id = newRow.lot_create_produce_work_save_warehouse_id;
          row_save_section_id = newRow.lot_create_produce_work_save_section_id;
          row_quality_exam_yn = newRow.lot_create_produce_work_quality_exam_yn;
        }
      } else {
        // 기존행은 원본과 비교
        createlotRows.map((data) => data.id === newRow.id && (
          data.lot_create_produce_work_save_workplace_id !== newRow.lot_create_produce_work_save_workplace_id ||
          data.lot_create_produce_work_save_warehouse_id !== newRow.lot_create_produce_work_save_warehouse_id ||
          data.lot_create_produce_work_save_section_id !== newRow.lot_create_produce_work_save_section_id ||
          data.lot_create_produce_work_quality_exam_yn !== newRow.lot_create_produce_work_quality_exam_yn
        ) ? (
          row_save_workplace_id = data.lot_create_produce_work_save_workplace_id,
          row_save_warehouse_id = data.lot_create_produce_work_save_warehouse_id,
          row_save_section_id = data.lot_create_produce_work_save_section_id,
          row_quality_exam_yn = data.lot_create_produce_work_quality_exam_yn
        ) : '' );
      }

      // 원복 판단
      if (
        row_save_workplace_id === null &&
        row_save_warehouse_id === null &&
        row_save_section_id === null &&
        row_quality_exam_yn === 'N'
      ) {
        if (updateCreateLotRows.length > 0) {
          setUpdateCreateLotRows(prev => prev.filter(d => d.id !== newRow.id));
          setCreateLotRows(prev => prev.map(d => d.id === newRow.id ? newNoDataArray : d));
        }
        return newNoDataArray;
      } else {
        // 업데이트 반영
        let exists = 'N';
        for (let i = 0; i < updateCreateLotRows.length; i++) {
          if (updateCreateLotRows[i].id === newRow.id) {
            exists = 'Y';
            break;
          }
        }

        if (exists === 'Y') {
          setUpdateCreateLotRows(prev => prev.map(d => d.id === newRow.id ? newUpdateDataArray : d));
          setCreateLotRows(prev => prev.map(d => d.id === newRow.id ? newUpdateDataArray : d));
        } else {
          setUpdateCreateLotRows(prev => [...prev, newUpdateDataArray]);
          setCreateLotRows(prev => prev.map(d => d.id === newRow.id ? newUpdateDataArray : d));
        }
        return newUpdateDataArray;
      }
    }

    return { ...newRow };
  };

  // 생산Lot 생성/갱신/삭제
  const createLotRow = (tempItemRow, tempNewUpdateData, tempType, changeDate, startNumber = '0') => {
    if (tempType !== 'D') {
      const target = String(tempNewUpdateData?.produce_work_item_id ?? '');
      const finished = String(inputs.produce_work_item_id ?? '');
      if (!target || target !== finished) return;
    }
    
    if (tempType === 'D') {
      setCreateLotRows(prev => prev.filter(r => r.upper_id !== tempNewUpdateData.id));
      setUpdateCreateLotRows(prev => prev.filter(r => r.upper_id !== tempNewUpdateData.id));
      return;
    }

    const now_lot_date_count = startNumber !== '0' ? startNumber : createLotNoStartNumber;

    const nextLotRows = [];
    const nextUpdateLotRows = [];

    // 기존 생성된 생산Lot들과 충돌 없도록 현재 상태 기준 id 산정
    let nextId = Number(appStore.getMaxListID(createlotRows)) + 1;

    let now_lot_no_count = '1';
    const source = tempItemRow && tempItemRow.length > 0 ? tempItemRow : [tempNewUpdateData];

    for (const row of source) {
      const payload = (row.id === tempNewUpdateData?.id && tempNewUpdateData?.id) ? tempNewUpdateData : row;
      now_lot_no_count = buildLotRowsForItem({
        insertData: payload,
        lotDateCount: now_lot_date_count,
        startNo: now_lot_no_count,
        changeDate,
        takeId: () => nextId++,
        pushLot: (lot) => { nextLotRows.push(lot); nextUpdateLotRows.push({ ...lot }); }
      });
    }

    setCreateLotRows(nextLotRows);
    setUpdateCreateLotRows(nextUpdateLotRows);
  };

  const buildLotRowsForItem = ({ insertData, lotDateCount, startNo, changeDate, takeId, pushLot }) => {
    const count = Number(insertData.produce_work_item_count || 0);
    let cur = Number(startNo);

    if (!insertData.produce_work_item_id || count <= 0) return String(cur);

    for (let i = cur; i < cur + count; i++) {
      const tempDate = String(lotDateCount ?? '1').toString().padStart(3, '0');
      const tempNo = i.toString().padStart(5, '0');
      const baseDate = changeDate && changeDate.length >= 8 ? changeDate : appStore.YYYY_MM_DD();
      const tempLotNo = 'W' + Moment(baseDate).format('YYMMDD') + tempDate + '-' + tempNo;

      const lotRow = {
        id: takeId(),
        upper_id: insertData.id,
        lot_no: tempLotNo,
        lot_create_produce_work_item_id: insertData.produce_work_item_id,
        lot_create_produce_work_item_name: insertData.produce_work_item_name,
        lot_create_produce_work_item_spec: insertData.produce_work_item_spec,
        lot_create_produce_work_quality_exam_yn: insertData.produce_work_quality_exam_yn,
        lot_create_produce_work_save_workplace_id: null,
        lot_create_produce_work_save_workplace_name: '',
        lot_create_produce_work_save_warehouse_id: null,
        lot_create_produce_work_save_warehouse_name: '',
        lot_create_produce_work_save_section_id: null,
        lot_create_produce_work_save_section_name: '',
        row_type: insertData.row_type,
        update_type: insertData.update_type
      };

      pushLot(lotRow);
    }

    return String(cur + count);
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    //자원 담당자 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

    if(oldRow.produce_work_user_id !== newRow.produce_work_user_id || oldRow.produce_work_user_type !== newRow.produce_work_user_type || oldRow.produce_work_user_bigo !== newRow.produce_work_user_bigo){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_produce_work_user_id = '';
      var row_produce_work_user_name = '';
      var row_produce_work_user_type = '';
      var row_produce_work_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.produce_work_user_id !== '' || newRow.produce_work_user_name !== '' || (newRow.produce_work_user_type !== '' && newRow.produce_work_user_type !== null) || newRow.produce_work_user_bigo !== '' ){
          row_produce_work_user_id = newRow.produce_work_user_id;
          row_produce_work_user_name = newRow.produce_work_user_name;
          row_produce_work_user_type = newRow.produce_work_user_type;
          row_produce_work_user_bigo = newRow.produce_work_user_bigo;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        userRows.map((data) => data.id === newRow.id 
          && (data.produce_work_user_id !== newRow.produce_work_user_id || data.produce_work_user_name !== newRow.produce_work_user_name || data.produce_work_user_type !== newRow.produce_work_user_type || data.produce_work_user_bigo !== newRow.produce_work_user_bigo )?
          (
            row_produce_work_user_id = data.produce_work_user_id,
            row_produce_work_user_name = data.produce_work_user_name,
            row_produce_work_user_type = data.produce_work_user_type,
            row_produce_work_user_bigo = data.produce_work_user_bigo
          ):""
        )
      }
      
      // 변경 후 값이 모두 비어있는 경우(신규행 초기화/전체 원복 등)만 '변경 없음'으로 처리
      if((newRow.produce_work_user_id === '' || newRow.produce_work_user_id === undefined) 
        && (newRow.produce_work_user_name === '' || newRow.produce_work_user_name === undefined)
        && (newRow.produce_work_user_bigo === '' || newRow.produce_work_user_bigo === undefined)
        && (newRow.produce_work_user_type === '' || newRow.produce_work_user_type === null || newRow.produce_work_user_type === undefined)){
        // 1. 값이 수정되지 않은 경우.
        if(updateUserRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateUserRows.length);
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }

        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const itemAddClick = (object) => {
    //생산작업 품목 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        produce_work_item_id: '',
        produce_work_item_name: '',
        produce_work_item_spec: '',
        produce_work_item_count: '',
        produce_work_quality_exam_yn: 'N',
        produce_work_item_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        produce_work_item_id: object.row.produce_work_item_id,
        produce_work_item_name: object.row.produce_work_item_name,
        produce_work_item_spec: object.row.produce_work_item_spec,
        produce_work_item_count: object.row.produce_work_item_count,
        produce_work_quality_exam_yn: object.row.produce_work_quality_exam_yn,
        produce_work_item_bigo: object.row.produce_work_item_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
    setItemRows((itemRows) => [...itemRows, { 
      id: Number(appStore.getMaxListID(itemRows))+1,
      produce_work_item_id: '',
      produce_work_item_name: '',
      produce_work_item_spec: '',
      produce_work_item_count: '',
      produce_work_quality_exam_yn: 'N',
      produce_work_item_bigo: '',
      row_type:'A',
      update_type: 'N'
    }]);
  };

  const itemDeleteClick = (object) => {
    //생산작업 품목 삭제 버튼
    setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
    searchLotRow(object.row, 'D')
    // 생산Lot 삭제 동기화
    createLotRow(itemRows, object.row, 'D', '')
  };

  const userAddClick = (object) => {
    //생산작업 담당자 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        produce_work_user_id: '',
        produce_work_user_name: '',
        produce_work_user_dept_name: '',
        produce_work_user_position_name: '',
        produce_work_user_type: '',
        produce_work_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        produce_work_user_id: object.row.produce_work_user_id,
        produce_work_user_name: object.row.produce_work_user_name,
        produce_work_user_dept_name: object.row.produce_work_user_dept_name,
        produce_work_user_position_name: object.row.produce_work_user_position_name,
        produce_work_user_type: object.row.produce_work_user_type,
        produce_work_user_bigo: object.row.produce_work_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    //생산작업 담당자 삭제 버튼
    setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {

      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
      }
      
      var array = [];
      for(var i=0; i<realFiles.length; i++){
        var tmp_sever_file_name = realFiles[i].name;
        var tmp_file_name = realFiles[i].name;
        var tmp_file_size = realFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(realFiles[i].size);
        var tmp_file_type = realFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(realFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows(array);
    }
  };

  const fileDeleteClick = (object) => {
    //생산작업 파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }
    setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //생산작업 파일 다운로드
  };
  
  const handleOnCellClick = (params) => {
    if(params.field === 'produce_work_item_name' || params.field === 'produce_work_item_spec' ){
      setSelectModalTitle('품목 목록');
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: params.row.id,
        produce_work_item_id: params.row.produce_work_item_id,
        produce_work_item_name: params.row.produce_work_item_name,
        produce_work_item_spec: params.row.produce_work_item_spec,
        produce_work_item_count: params.row.produce_work_item_count,
        produce_work_quality_exam_yn: params.row.produce_work_quality_exam_yn,
        produce_work_item_bigo: params.row.produce_work_item_bigo,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'produce_work_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        produce_work_user_id: params.row.produce_work_user_id,
        produce_work_user_name: params.row.produce_work_user_name,
        produce_work_user_dept_name: params.row.produce_work_user_dept_name,
        produce_work_user_position_name: params.row.produce_work_user_position_name,
        produce_work_user_type: params.row.produce_work_user_type,
        produce_work_user_bigo: params.row.produce_work_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handlePartnerUserClick = (object) => {
    //생산작업처 모달에서 클릭한 값으로 생산작업처 및 담당자 데이터 설정함.
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email
    var partner_delivery_post = object.partner_head_address_post === undefined?'':object.partner_head_address_post
    var partner_delivery_address = object.partner_head_address === undefined?'':object.partner_head_address
    var partner_delivery_address_add = object.partner_head_address_addition === undefined?'':object.partner_head_address_addition

    const nextInputs = {
        ...inputs,
        ["produce_work_partner_id"]: object.id,
        ["produce_work_partner_name"]: object.partner_name,
        ["produce_work_partner_manager"]: partner_user_name,
        ["produce_work_partner_manager_phone"]: partner_user_phone,
        ["produce_work_partner_manager_mail"]: partner_user_email,
        ["produce_work_partner_delivery_post"]: partner_delivery_post,
        ["produce_work_partner_delivery_address"]: partner_delivery_address,
        ["produce_work_partner_delivery_address_add"]: partner_delivery_address_add,
    };
    setInputs(nextInputs);
  };
  
  const handleInputItemClick = (object) => {
    //품목 목록 모달에서 클릭한 값으로 생산작업 품목 데이터 설정함.
    let item_id = object.id
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(String(itemRows[i].produce_work_item_id) === String(object.id) && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.produce_work_item_id){
        processItemRowUpdate(
          {
            id: selectItemData.id,
            produce_work_item_id: object.id,
            produce_work_item_name: object.item_name,
            produce_work_item_spec: appStore.ITEM_FULL_SPEC_MAKE(object.item_spec, object.item_width, object.item_depth, object.item_height),
            produce_work_item_count: '',
            produce_work_quality_exam_yn: selectItemData.produce_work_quality_exam_yn,
            produce_work_item_bigo: selectItemData.produce_work_item_bigo,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          },
          {
            id: selectItemData.id,
            produce_work_item_id: selectItemData.produce_work_item_id,
            produce_work_item_name: selectItemData.produce_work_item_name,
            produce_work_item_spec: selectItemData.produce_work_item_spec,
            produce_work_item_count: selectItemData.produce_work_item_count,
            produce_work_quality_exam_yn: selectItemData.produce_work_quality_exam_yn,
            produce_work_item_bigo: selectItemData.produce_work_item_bigo,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          }
        )
      }
    }
  };

  const handleUserClick = (object) => {
    //입고담당자 모달에서 클릭한 값으로 입고담당자 데이터 설정함.
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].produce_work_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.user_id){
        processUserRowUpdate(
          {
            id : selectUserData.id,
            produce_work_user_id: object.id,
            produce_work_user_name: object.user_name,
            produce_work_user_dept_name: object.dept_name,
            produce_work_user_position_name: object.position_name,
            produce_work_user_type: selectUserData.produce_work_user_type,
            produce_work_user_bigo: selectUserData.produce_work_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            produce_work_user_id: selectUserData.produce_work_user_id,
            produce_work_user_name: selectUserData.produce_work_user_name,
            produce_work_user_type: selectUserData.produce_work_user_type,
            produce_work_user_dept_name: selectUserData.produce_work_user_dept_name,
            produce_work_user_position_name: selectUserData.produce_work_user_position_name,
            produce_work_user_bigo: selectUserData.produce_work_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';
    let noMaterYN = 'N';
    if(inputs.produce_work_bom_id === 0 || inputs.produce_work_bom_id === ''){
      msg = 'BOM은 필수 선택 입니다.'
    }else if((inputs.produce_work_start_datetime || '').trim() === '' || (inputs.produce_work_start_datetime || '').length < 16){
      msg = '작업시작일시 입력이 올바르지 않습니다.'
    }else if((inputs.produce_work_end_datetime || '').trim() === '' || (inputs.produce_work_end_datetime || '').length < 16){
      msg = '작업종료일시 입력이 올바르지 않습니다.'
    }else if(new Date(inputs.produce_work_end_datetime) <= new Date(inputs.produce_work_start_datetime)){
      msg = '작업종료일시는 작업시작일시 이후여야 합니다.'
    }else if(inputs.produce_work_count == 0){
      msg = '작업생산수량은 1개 이상이어야 합니다.'
    }

    if(msg === '' && itemRows.length === 0){ 

      noMaterYN = 'Y';

    }else if(itemRows.length > 0 && msg === ''){
      for(let i = 0; i < itemRows.length; i++) {
        const item_id = itemRows[i].produce_work_item_id;
        const item_name = (itemRows[i].produce_work_item_name).trim();
        const item_count = itemRows[i].produce_work_item_count;
        for(let j = i+1; j < itemRows.length; j++) {
          if(item_id === itemRows[j].produce_work_item_id && item_id !== '' && item_id !== 0) {
            msg = '중복된 사용품목명이 존재합니다.<br/>[중복된 사용품목명 : '+item_name+']';
            break;
          }
          if(item_count === 0 || item_count < 0 || item_count === '') {
            msg = '입력되지 않는 사용품목 수량이 존재합니다.';
            break;
          }
        }

        if(msg !== '')  {
          break;
        }
      }

      for(let i = 0; i < updateItemRows.length; i++) {
        const item_id = updateItemRows[i].produce_work_item_id;
        const item_count = updateItemRows[i].produce_work_item_count;
        if(item_id === 0 || item_id === '') {
          msg = '선택되지 않는 사용품목명이 존재합니다.';
          break;
        }
        if(item_count === 0 || item_count < 0 || item_count === '') {
          msg = '입력되지 않는 사용품목 수량이 존재합니다.';
          break;
        }
      }
    }
    
    
    // 생산작업담당자
    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < updateUserRows.length; i++) {
        const produce_work_user_id = updateUserRows[i].produce_work_user_id;
        const produce_work_user_type = updateUserRows[i].produce_work_user_type;
        
        if(produce_work_user_id === 0 || produce_work_user_id === '') {
          msg = '선택되지 않는 담당자명이 존재합니다.';
          break;
        }
        if(produce_work_user_type === 0 || produce_work_user_type === '') {
          msg = '선택되지 않는 담당자유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">생산작업 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else {
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/ProduceWork/Reg", {inputs, updateItemRows, updateUserRows, updateLotRows, updateCreateLotRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          var selectID = response.data;
          if(String(selectID) === '-1'){
            Swal.fire({
              title: '<p style="color:red">생산작업 LotNo 변경 발생</p>',
              text: '생산작업 등록할 LotNo의 변경이 발생했습니다.',
              confirmButtonText: '확인'
            });
          }else{
            if(updateFileRows.length > 0) {

              const formData = new FormData();
              formData.append('selectID', selectID);
              formData.append('folder', 'ProduceWork');
              formData.append('type', 'Reg');
              formData.append('updateFileRows', JSON.stringify(updateFileRows));
              
              for(var i=0; i<realFiles.length; i++){            
                formData.append('files', realFiles[i]);
              }
              
              axios.post('/api/SaveCommon/GridFileSave'
                  , formData
                  , { headers: { 'Content-Type': 'multipart/form-data' } 
              }).then(response => {
                handleRegSuccessSave(selectID);
              }).catch(error => {
                appStore.capture();
              });
  
            }else{
  
              handleRegSuccessSave(selectID);
  
            }
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });
    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="생산작업 정보" value="1" />
                <Tab label="생산작업 품목" value="2" />
                <Tab label="생산작업 사용Lot" value="3" />
                <Tab label="생산작업 생산Lot" value="4" />
                <Tab label="생산작업 담당자" value="5" />
                <Tab label="생산작업 파일" value="6" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">생산작업번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="생산작업번호" value={inputs.produce_work_number} name="produce_work_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">BOM<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="BOM" value={inputs.produce_work_bom_name} name="produce_work_bom_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', cursor: 'pointer'}} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">품목</div>
                        <div className="modal_filed_input" style={ { display:'flex', width: '769px' } }>
                        <input type="text" style={ { width: '150px', backgroundColor: '#EFEFEF4D', color: 'black' } } value={inputs.produce_work_item_name} name="produce_work_item_name" autoComplete="off" readOnly />
                        &nbsp;&nbsp;
                        <input type="text" style={ { width: '80px', backgroundColor: '#EFEFEF4D', color: 'black' } } value={inputs.produce_work_item_type_name} name="produce_work_item_type_name" autoComplete="off" readOnly />
                        &nbsp;&nbsp;
                        <input type="text" style={ { width: '120px', backgroundColor: '#EFEFEF4D', color: 'black' } } value={inputs.produce_work_item_division_name} name="produce_work_item_division_name" autoComplete="off" readOnly />
                        &nbsp;&nbsp;
                        <input type="text" style={ { width: '450px', backgroundColor: '#EFEFEF4D', color: 'black' } } value={inputs.produce_work_item_spec} name="produce_work_item_spec" autoComplete="off" readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">생산시작일시<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="datetime-local" placeholder="생산시작일시" value={inputs.produce_work_start_datetime} name="produce_work_start_datetime" onChange={(e) => onChange(e) } autoComplete="off" style={ { fontWeight:'bold', color: 'black' } } min="2025-09-01T00:00" max="2099-12-31T23:59" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">생산종료일시<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="datetime-local" placeholder="생산종료일시" value={inputs.produce_work_end_datetime} name="produce_work_end_datetime" onChange={(e) => onChange(e) } autoComplete="off" style={ { fontWeight:'bold', color: 'black' } } min="2025-09-01T00:00" max="2099-12-31T23:59" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">생산작업수량</div>
                        <div className="modal_filed_input" style={ { display:'flex', width: '153.8px' } }>
                          <input type="number" placeholder="생산작업수량" value={inputs.produce_work_count} name="produce_work_count" disabled={true} onChange={(e) => onChange(e) } autoComplete="off" style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                        <div className="modal_filed_title"style={ { display:'flex', width: '153.8px' } }>&nbsp;&nbsp;&nbsp;정품수량</div>
                        <div className="modal_filed_input" style={ { display:'flex', width: '153.8px' } }>
                          <input type="number" placeholder="정품수량" value={inputs.produce_work_complete_count} name="produce_work_complete_count" onChange={(e) => onChange(e) } autoComplete="off" style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                        <div className="modal_filed_title"style={ { display:'flex', width: '153.8px' } }>&nbsp;&nbsp;&nbsp;불량수량</div>
                        <div className="modal_filed_input" style={ { display:'flex', width: '153.8px' } }>
                          <input type="number" placeholder="불량수량" value={inputs.produce_work_error_count} name="produce_work_error_count" onChange={(e) => onChange(e) } autoComplete="off" style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="비고" name="produce_work_bigo" value={inputs.produce_work_bigo} onChange={(e) => onChange(e) } style={{width: '768px', height: '110px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={itemApiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'
                  processRowUpdate={processItemRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={lotApiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'
                  processRowUpdate={processLotRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={createlotApiRef}
                  rows={createlotRows}
                  columns={createlotColumns}
                  columnVisibilityModel={createlotColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processCreateLotRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="5" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={userApiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="6" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {MenuUpdateYN === 'Y' &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                      </Button> }
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectBOMModalOpen && (<BOMSelectModal
          onClose={() => {
              setSelectBOMModalOpen(false);
          }}
          title={selectmodalTitle}
          handleBOMClick={handleBOMClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          handleInputItemClick={handleInputItemClick}
          />)}

        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </PCModal>
  );
}

export default ProduceWorkRegModal;